module.exports = __webpack_public_path__ + "img/default2.11629652.png";